import { useState, useEffect } from 'react';
import { onAuthChange, handleRedirectResult } from '../services/auth';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Handle redirect result for iOS Safari
    handleRedirectResult().catch(error => {
      console.error('Redirect result error:', error);
    });

    const unsubscribe = onAuthChange((user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return { user, loading };
}
